<template>
  <div class="app">
    <router-view class="child-view" v-if="isMiniProgram"></router-view>
    <transition :name="transitionName" v-else>
      <router-view class="child-view"></router-view>
    </transition>
  </div>
</template>

<script>
import { isMiniProgram } from './utils/isMiniProgram'
export default {
  name: 'app',
  data () {
    return {
      isMiniProgram: isMiniProgram()
    }
  },
  computed: {
    transitionName () {
      return this.$store.getters.getDirection
    }
  }
}
</script>

<style lang="less">
@import "./assets/weui";
.app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  position: relative;
}
.child-view {
  position: absolute;
  width: 100%;
  transition: all .5s cubic-bezier(.55,0,.1,1);
}
.forward-enter, .back-leave-active {
  opacity: 0;
  -webkit-transform: translate(100%, 0);
  transform: translate(100%, 0);
}
.forward-leave-active, .back-enter {
  opacity: 0;
  -webkit-transform: translate(-100%, 0);
  transform: translate(-100%, 0);
}
div[name="scroll"] {
  /* padding-top: 40px; */
  background-color: #fff;
  -webkit-overflow-scrolling: touch;
}
</style>
